import { signal } from "@preact/signals-react";

export const favFiltersData = signal([])